module.exports = __webpack_public_path__ + "img/changeFinish-2@2x.eff752b.webp";